export default function VerificationIco() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8712 1.13749C14.7855 1.04954 14.6681 1 14.5453 1H9.45445C9.33174 1 9.21425 1.04977 9.12857 1.13749C9.04267 1.22521 8.99677 1.34429 9.00018 1.467L9.38196 15.2834C9.38855 15.5293 9.59012 15.725 9.83624 15.725H14.1645C14.4106 15.725 14.6124 15.5293 14.6187 15.283L14.9998 1.467C15.003 1.34451 14.9569 1.22543 14.8712 1.13749Z"
        fill="black"
      />
      <path
        d="M14.1554 18.0547H9.84513C9.59424 18.0547 9.39062 18.2583 9.39062 18.5092V22.4952C9.39062 22.7461 9.59424 22.9497 9.84513 22.9497H14.1559C14.4067 22.9497 14.6104 22.7461 14.6104 22.4952V18.5092C14.6099 18.2583 14.4067 18.0547 14.1554 18.0547Z"
        fill="black"
      />
    </svg>
  );
}
